import React from 'react'

import Button from 'src/components/Button/Button'
import { Layout, Container, Header } from 'src/components/Layout'

import Spin from 'src/components/Spin'
import styles from './styles.module.less'

const Loadable = ({ error, retry, brand }) => {
  if (error) {
    return (
      <div style={{ textAlign: 'center' }}>
        <h2>Error loading page!</h2>
        <Button size='large' onClick={retry}>
          Retry
        </Button>
      </div>
    )
  } else {
    return (
      <Layout>
        <Header
          title={brand.hasOwnProperty('name') && brand.name ? brand.name : ''}
          hideOnDesktop={true}
        />
        <Container>
          <div className={styles.spinner}>
            <Spin />
          </div>
        </Container>
      </Layout>
    )
  }
}

export default Loadable
